"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const facultyMembers = [{
  id: 1,
  name: "Elena Petrov",
  title: "Principal Instructor",
  bio: "Former principal dancer with the Bolshoi Ballet, Elena brings twenty years of international performance and pedagogy to our institution.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/elena_petrov_faculty.png"
}, {
  id: 2,
  name: "Marcus Chen",
  title: "Director of Technique",
  bio: "Trained at the Royal Ballet School, Marcus specializes in classical technique and has coached dancers at elite companies worldwide.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/marcus_chen_faculty.png"
}, {
  id: 3,
  name: "Sofia Ramirez",
  title: "Artistic Coordinator",
  bio: "With extensive experience in curriculum development, Sofia ensures our programs maintain the highest international standards of ballet education.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/sofia_ramirez_faculty.png"
}];
export default function Faculty() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const refs = [section1Ref, section2Ref, section3Ref];
  const visibilities = [section1Visible, section2Visible, section3Visible];
  return;
}